<template>
  <div class="not_found_page d-flex-column justify-start gap-30">
    <img
      src="/images/four_zero_four.webp"
      alt="four zero four page image"
      class="four_zero_four"
      width="422"
      height="277"
    />
    <h3 class="t-white font-family-1 f-w-500 title-h3">
      {{ $t("not_found_page.title") }}
    </h3>
    <button
      :to="'/'"
      class="primary filled xl height-48 full-width max-width-213px b-radius-9 t-black font-family-1 f-w-600"
      @click="handleClearError"
    >
      {{ $t("not_found_page.homepage") }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps(["error"]);
console.log(props.error);
const localePath = useLocalePath();

const handleClearError = () => {
  clearError({
    redirect: localePath("/"),
  });
};

if (process.server) {
  const event = useRequestEvent();
  setResponseStatus(event, 404);
}
</script>
